import { render, staticRenderFns } from "./reqBoard.vue?vue&type=template&id=cf390a30&scoped=true"
import script from "./reqBoard.vue?vue&type=script&lang=js"
export * from "./reqBoard.vue?vue&type=script&lang=js"
import style0 from "./reqBoard.vue?vue&type=style&index=0&id=cf390a30&prod&scoped=true&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf390a30",
  null
  
)

export default component.exports